import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["loading"];

  connect(){
    this.requestTemplateIdInput = document.querySelector('#request-anamnese [name="anamnese_patient[anamnese_template_id]"]');
    this.templateIdInput = this.element.querySelector('.anamnese-template-id-select')
    $(this.templateIdInput).on('change', (e) => {
      this.change(e.target.value, e.target.dataset.url);
    })
  }

  change(requestTemplateId, url) {
    const containerElement = document.querySelector('#anamnese-questions')
    this.loadingTarget.classList.remove("tw-hidden");
    containerElement.classList.add("tw-hidden");
    this.requestTemplateIdInput.value = requestTemplateId
    containerElement.innerHTML = ''

    $.ajax({
      url: `${url}.js?anamnese_template_id=${
        requestTemplateId
      }`
    }).done((data) => {
      this.loadingTarget.classList.add("tw-hidden");
      containerElement.classList.remove("tw-hidden");
    }).fail((xhr) => {
      toastr.error('Infelizmente não foi possível carregar as perguntas.')
    })
  }
}
